import {axiosInstance as axios} from '../helpers/axios';
import {setErrors} from "./errorActions";
import {tokenConfig} from "./authActions";
import {setSuccess} from "./successActions";

import {
    CLEAR_PAYMENT_STATE_LOADING,
    CLEAR_PAYMENT_STATES_LOADING,
    GET_PAYMENT_STATES,
    PAYMENT_STATE_ERROR,
    PAYMENT_STATE_LOADING,
    PAYMENT_STATES_ERROR,
    PAYMENT_STATES_LOADING,
} from "./types";

export const getAllPaymentStates = () => async (dispatch) => {
    try {
        dispatch({type: PAYMENT_STATES_LOADING});

        const res = await axios.get('/api/v1/payment', tokenConfig());

        dispatch({
            type: GET_PAYMENT_STATES,
            payload: res.data.data,
        });


    } catch (err) {
        dispatch(setErrors(err, PAYMENT_STATES_ERROR));
    } finally {
        dispatch({type: CLEAR_PAYMENT_STATES_LOADING});
    }
}

export const createPaymentState = paymentState => async dispatch => {
    try {
        dispatch({type: PAYMENT_STATE_LOADING});

        const res = await axios.post('/api/v1/payment', paymentState, tokenConfig());

        dispatch({
            type: GET_PAYMENT_STATES,
            payload: res.data.data,
        });

        dispatch(setSuccess(res));

    } catch (err) {
        dispatch(setErrors(err, PAYMENT_STATE_ERROR));
    } finally {
        dispatch({type: CLEAR_PAYMENT_STATE_LOADING});
    }
}


export const updatePaymentState = paymentState => async dispatch => {
    try {
        dispatch({type: PAYMENT_STATE_LOADING});

        const res = await axios.put('/api/v1/payment', paymentState, tokenConfig());

        dispatch({
            type: GET_PAYMENT_STATES,
            payload: res.data.data,
        });

        dispatch(setSuccess(res));

    } catch (err) {
        dispatch(setErrors(err, PAYMENT_STATE_ERROR));
    } finally {
        dispatch({type: CLEAR_PAYMENT_STATE_LOADING});
    }
}

export const deletePaymentState = paymentState => async dispatch => {
    try {
        dispatch({type: PAYMENT_STATE_LOADING});

        const config = {
            ...tokenConfig(),
            data: paymentState,
        }

        const res = await axios.delete('/api/v1/payment', config);

        dispatch({
            type: GET_PAYMENT_STATES,
            payload: res.data.data,
        });

        dispatch(setSuccess(res));

    } catch (err) {
        dispatch(setErrors(err, PAYMENT_STATE_ERROR));
    } finally {
        dispatch({type: CLEAR_PAYMENT_STATE_LOADING});
    }
}